<template>
  <div id="addProject">
    <div class="input-list">
      <div class="columns">
        <form @submit.prevent="add">
          <div class="field">
            <label class="label">Project Name</label>
            <div class="control">
              <input v-model="projectname" type="text" class="addProject-inputField" placeholder="Project Name" required>
            </div>
          </div>

          <div class="field">
            <label class="label">Why do you work on this?</label>
            <div class="control">
              <textarea v-model="why" class="addProject-inputField" placeholder="Why?" required />
            </div>
          </div>

          <div class="field">
            <label class="label">Where are you at?</label>
            <div class="control">
              <select v-model="phase" class="addProject-inputField" required>
                <option disabled value="">
                  Where are you at?
                </option>
                <option>Daydreaming</option>
                <option>Ideation / Sketching</option>
                <option>Conceptualizing</option>
                <option>Prototyping</option>
                <option>Development</option>
                <option>Finalizing</option>
                <option>Launching</option>
                <option>Publishing</option>
                <option>Funding</option>
              </select>
            </div>
          </div>

          <div class="field">
            <label class="label">Callout</label>
            <div class="control">
              <select v-model="callout" class="addProject-inputField" required>
                <option disabled value="">
                  What are you looking for?
                </option>
                <option>Casual talk</option>
                <option>Interviewee</option>
                <option>Validation</option>
                <option>Teammates</option>
                <option>Founders</option>
                <option>Investor</option>
                <option>Publisher</option>
              </select>
            </div>
          </div>

          <div class="field">
            <label class="label">Share it in Public?</label>
            <div class="control">
              <input v-model="isPublic" type="checkbox" class="addProject-inputField" true-value="true" false-value="false">
            </div>
          </div>

          <div class="field">
            <div class="control">
              <button type="submit">
                Add This Project!
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from '@/firebase/firestore';
import projectHandler from '@/js/projectHandler.js';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'NewProject',
  data() {
    return {
      createdAt: new Date(),
      userId: firebase.auth().currentUser.uid,
      projectname: null,
      why: null,
      phase: null,
      callout: null,
      isPublic: null,
    };
  },
  computed: {
    ...mapGetters(['projectInfo', 'loadStatus']),
  },
  methods: {
    ...mapActions(['fetchDatabase']),
    add() {
      projectHandler.addProject(this.createdAt, this.userId, this.projectname, this.why, this.phase, this.callout, this.isPublic);
      this.fetchDatabase(this.userid);
    },   
  },
};
</script>

<style lang="scss" scoped>
.input-list {
  margin-top: -35px;
  border-radius: 10px;
  background-color: rgb(252, 252, 252);
  padding: 30px;
  box-shadow: 0 0 5px 0 rgba(0,0,0,0.05);
}
.field {
  margin-bottom: 10px;
  .label {
    float: left;
  }
  .addProject-inputField{
    width: 100%;
  }
  input{  
    height: 30px;
    border: solid #42b983 1px;
  }
  textarea{
    height: 50px;
    border: solid #42b983 1px;
  }
  select{
    height: 30px;
    border: solid #42b983 1px;
  }
  button  {
  border: solid #42b983 1px;
  margin-left: 5px;
  }
}
</style>
